import { makeActionCreator } from "../../utils";

export const TOTALS_DATA_CHANGED = "EXTERNALS.TOTALS.TOTALS_DATA_CHANGED";

export const totalsDataChanged = makeActionCreator(TOTALS_DATA_CHANGED, "payload");
